export default function ShiftSlide() {
  return (
    <div className="max-w-6xl w-full mx-auto relative z-10">
      <div className="text-center mb-20">
        <h2 className="font-display text-6xl mb-4">Crypto capital allocation is maturing from chaos to coordination.</h2>
      </div>

      <div className="grid grid-cols-1 md:grid-cols-2 gap-8 items-center relative">
        {/* Arrow */}
        <div className="hidden md:flex absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 z-20 items-center justify-center text-avo-lime text-4xl font-bold">
          →
        </div>

        {/* Manual Era */}
        <div className="glass-panel p-10 rounded-3xl border-l-4 border-l-red-500/50">
          <div className="text-red-400 font-pixel text-2xl mb-4">THE HUMAN ERA</div>
          <h3 className="font-display text-[2.75rem] mb-6">Casino Ponzinomics</h3>
          <ul className="space-y-4 text-gray-400 text-lg">
            <li className="flex items-center gap-3">
              <span className="text-red-500">✕</span> 24/7 trenching, human fatigue
            </li>
            <li className="flex items-center gap-3">
              <span className="text-red-500">✕</span> Emotional trading & FOMO
            </li>
            <li className="flex items-center gap-3">
              <span className="text-red-500">✕</span> Capital flows to noise, not signal
            </li>
          </ul>
        </div>

        {/* Autonomous Era */}
        <div className="glass-panel p-10 rounded-3xl border-l-4 border-l-avo-lime bg-gradient-to-br from-avo-card to-avo-lime/5">
          <div className="text-avo-lime font-pixel text-2xl mb-4">THE AUTONOMOUS ERA</div>
          <h3 className="font-display text-[2.75rem] mb-6 text-white">Intelligent Allocation</h3>
          <ul className="space-y-4 text-gray-300 text-lg">
            <li className="flex items-center gap-3">
              <span className="text-avo-lime">✓</span> Agents are tireless
            </li>
            <li className="flex items-center gap-3">
              <span className="text-avo-lime">✓</span> Subtract human emotion
            </li>
            <li className="flex items-center gap-3">
              <span className="text-avo-lime">✓</span> Data-driven decisions
            </li>
          </ul>
        </div>
      </div>
    </div>
  );
}
